module.exports = __webpack_public_path__ + "img/chwl.3356fe01.png";